// Discussed Treatments Modal – "Select an item from the list" prompt

export default function SelectPrompt() {
  return (
    <div className="discussed-treatments-form-section discussed-treatments-select-prompt">
      <h3 className="discussed-treatments-form-title">BUILD PLAN</h3>
      <p className="discussed-treatments-form-hint">
        Select an item from the list to view or edit, or click &quot;+ Add
        new&quot; to add a treatment to the plan.
      </p>
    </div>
  );
}
